import React from 'react';
import { Input, Label } from 'reactstrap';
import { T } from '../traks';

const TypeSelector = (props) => {
    const setTranslateType = (type) => {
        const typeMap = {
            'Private': <T>Private</T>,
            'Company': <T>Company</T>,
            'Teacher': <T>Teacher</T>,
        };

        return typeMap[type] || type;
    }

    return (
        <div>
            <div className="mb-2"><b><T>Type:</T></b></div>
            {['Private', 'Company', 'Teacher'].map((type) => {
             return (
                <div key={`type-${type.toLowerCase()}`} className='radio-item pr-lg-3'>
                    <Input type="radio" className={props.className ? `${props.className}`  : "form-check-input"} id={`type_${type.toLowerCase()}`} name="customer_type" value={type.toLowerCase()} checked={type.toLowerCase() === props.type} onChange={props.onChange ? props.onChange : null} /> 
                    <Label className="form-check-label" for={`type_${type.toLowerCase()}`}>
                        <span>{setTranslateType(type)}</span>
                    </Label>
                </div>
            )})}
        </div>
    )
}

export default TypeSelector;


// WEBPACK FOOTER //
// ./src/c/TypeInput.js